<section class="container-flex contact-us-container page-section" *ngIf="submittedRequest">
  <div class="container-flex-row form-holder">
    <div class="content-holder form-section">
      <div class="form-holder">
        <div class="title-section">
          <h1 class="title">We're here to help!</h1>
          <p class="subtitle">Let us know how we can assist in making FreeUp a better experience for you.</p>
          <p>Please fill in the below form, and we'll be in touch within one business day.</p>
        </div>
        <form (ngSubmit)="sendMessage()" [formGroup]="contactUsForm" class="contactUsForm">
          <div class="four category">
            <select class="bold" id="category" [class.opened]="!!isOpened" formControlName="category"
              (focus)="isOpened = true" (blur)="isOpened = false" (change)="isOpened = false">
              <option class="bold" value="Billing"> Billing </option>
              <option class="bold" value="Technical">Technical Support</option>
              <option class="bold" value="Sales">Sales Support</option>
              <option class="bold" value="Order">Order Support</option>
              <option class="bold" value="New_Customer"><b>New Customer</b></option>
            </select>
          </div>
          <div class="twelve form-row">
            <div class="six input-section">
              <label for="name">Name<span class="text-color-secondary">*</span></label>
              <input class="bold" id="name" type="text" name="name" formControlName="name" required
                autocomplete="given-name">
              <fieldset class="validation-message">
                <label class="validation-message alert"
                  *ngIf="contactUsForm.controls.name.touched && contactUsForm.controls.name.hasError('required')">
                  Name is required
                </label>
                <label class="validation-message alert" *ngIf="contactUsForm.controls.name.hasError('pattern')">
                  Name is invalid
                </label>
              </fieldset>
            </div>
            <div class="six input-section">
              <label for="email">Email<span class="text-color-secondary">*</span></label>
              <input class="bold" id="email" type="text" name="email" formControlName="email" required
                autocomplete="email">
              <label class="validation-message alert"
                *ngIf="contactUsForm.controls.email.touched && contactUsForm.controls.email.hasError('required')">
                Email is required
              </label>
              <label class='validation-message' *ngIf="contactUsForm.controls.email.hasError('pattern')">
                Email is invalid.
              </label>
            </div>
          </div>
          <div class="twelve form-row numbers">
            <div class="six input-section">
              <div class="g2g-number">
                <label for="phone">My FreeUp Phone number</label>
                <p class="caption note">Your FreeUp phone number, or number you are transferring will help us assist you
                  more quickly.</p>
                <input restrictNumbers maxlength="10" class="bold" id="phone" type="tel" name="phone"
                  formControlName="phone" autocomplete="tel">
              </div>
              <div class="phoneNumber">
                <label for="contact">My Contact Number</label>
                <input restrictNumbers maxlength="10" class="bold" id="contact" type="tel" name="contact"
                  formControlName="contact" autocomplete="tel">
              </div>
            </div>
            <div class="six input-section">
              <label for="message">Message<span class="text-color-secondary">*</span></label>
              <textarea class="bold" id="message" name="message" id="message" cols="30" rows="15"
                formControlName="message" required></textarea><br>
              <label class="validation-message alert"
                *ngIf="contactUsForm.controls.message.touched && contactUsForm.controls.message.hasError('required')">
                Message is required
              </label>
            </div>
          </div>
          <div class="twelve form-row">
            <div class="six input-section">
              <p class="required"><span class="text-color-secondary">*</span>Required fields</p>
            </div>
          </div>
          <div class="twelve form-row">
            <div>
              <p class="caption required-res"><span class="text-color-secondary">*</span>Required fields</p>
            </div>
            <button type="submit" class="button primary max-content float-right " id="submitButton"
              name="contact-submit" [disabled]="!contactUsForm.valid"
              [uiBlockButton]="processingRequest">
              Submit
            </button>
          </div>
        </form>
        <div class="contact-info-section">
          <div class="left-section">
            <p class="smaller call"><img class="social-icon tel" src="assets/icon/call.svg" alt="call" /> <b>Call
                center:</b><a class="tel" href="tel:(888) 316-0686"> (888) 316-0686 </a></p>
            <p class="smaller call time">Available: 7AM to 1AM EST - Monday-Sunday</p>
          </div>
          <div class="right-section">
            <p class="smaller call right"> <b>Follow us on: </b></p>
            <div class="icons">
              <a href="https://www.facebook.com/freeupmobile/" target="_blank" rel="noreferrer"><img class="social-icon"
                  src="assets/icon/FB.svg" alt="facebook" /></a>
              <!-- <a href="https://www.facebook.com/freeupmobile/" target="_blank" rel="noreferrer"><img class="social-icon"  src="assets/icon/Youtube.svg" alt="youtube"/></a> -->
              <a href="https://www.instagram.com/freeupmobile/" target="_blank" rel="noreferrer"><img
                  class="social-icon twit" src="assets/icon/insta.svg" alt="instagram" /></a>
              <a href="https://twitter.com/freeupmobile" target="_blank" rel="noreferrer"><img class="social-icon twit"
                  src="assets/icon/Twitter.svg" alt="twitter" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-holder width-on-tablet">
      <div class="questions-holder">
        <div class="questions-title">
          <h5 class="title">More questions?</h5>
          <p class="subtitle">Learn about:</p>
        </div>
        <div class="questions">
          <h3 class="question"><a (click)="goToILDaddon()">International calling</a></h3>
          <h3 class="question"><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.DATA_SETUP]"
              routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">How to set up your phone data</a></h3>
          <h3 class="question"><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.COVERAGE]"
              routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">LTE Network - what is it?</a></h3>
        </div>
      </div>
      <div class="twelve contact" id="hide-section-two">
        <div class="six padding-bottom-10">
          <span class="call__sub"> <b class="font-size-20">Call center:</b> <b class="text-color-primary"><a
                href="tel:(888) 316-0686"> (888) 316-0686 </a></b></span>
          <br>
          <span class="call__sub"><b>Available: 7AM to 1AM EST</b></span>
          <br>
          <span class="call__sub"><b> Monday-Sunday</b></span>
          <br>
          <br>
        </div>
        <div class="six">
          <span class="call-us right">
            <div class="blue-rectangular">
              <a class="center-block" href="" target="_blank" rel="noreferrer"><img src="assets/img/call-us.png"
                  alt="call us" /></a>
            </div>
            <div class="purple-rectangular">
              <a class="center-block" href="https://www.facebook.com/freeupmobile/" target="_blank"
                rel="noreferrer"><img id="fb" src="assets/img/fb.png" alt="facebook" /></a>
            </div>
            <div class="purple-rectangular">
              <a class="center-block" href="https://twitter.com/freeupmobile" target="_blank" rel="noreferrer"><img
                  id="tweet" src="assets/img/tweet.png" alt="twitter" /></a>
            </div>
            <div class="purple-rectangular">
              <a class="center-block" href="https://www.instagram.com/freeupmobile/" target="_blank"
                rel="noreferrer"><img id="insta" src="assets/img/insta.png" alt="instagram" /></a>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="container-flex contact-us-after-submition" *ngIf="!submittedRequest">
  <h1 class="align-center main-title">Thank you for your feedback!</h1>
  <p class="smaller align-center main-paragraph">
    Our support team will reach out to you shortly. We live to make our customers happy!
    If you have any more questions or comments please don’t hesitate to call us on our
    customer care line.
  </p>
  <div class="align-center button-margin">
    <button class="button primary max-content" (click)="goBack()">
      Back to support
    </button>
  </div>
</section>